import React from 'react';
import PropTypes from 'prop-types';
import Years from './YearDrop';
import Sort from './SortDrop';
import './style.css'

/**
 * @name Filters
 * @function
 * @description Displays Filters
 * @returns {JSX}
 * @param {*} props 
 */
function Filters( props ){

    return (
        <div className="grid row filters">
            <div className="grid item">
                <Years labels={ props.labels.DictionaryLabels } callback={ props.callback }/>
            </div>
            <div className="grid item">
                <Sort labels={ props.labels.DictionaryLabels } callback={ props.callback } />
            </div>
        </div>
           
    );
}


Filters.propTypes = {
    labels: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired
};

export default Filters;